const ApiResponseUnmapper = require('../libraries/DigiTickets/Api/ApiResponseUnmapper');

const ReturnReasonResource = function ($resource, apiRequestParams, appConfig) {
    return $resource(
        appConfig.apiBaseUrl + 'returnreasons',
        apiRequestParams.defaults(),
        {
            query: {
                isArray: true,
                method: 'GET',
                params: apiRequestParams.defaultMappers(),
                transformResponse: (json) => ApiResponseUnmapper.transformApiResponse(json, 'ReturnReason'),
            },
        }
    );
};

module.exports = ReturnReasonResource;
